<div class="card topo">
  <div class="busca">
    <svg class="i sm" viewBox="0 0 24 24"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
    <input type="search" [(ngModel)]="busca" placeholder="Buscar agenda ou especialidade" aria-label="Buscar agenda ou especialidade" />
  </div>
  <span class="info">
    <ng-container *ngIf="nomeUnidade">{{ nomeUnidade }} · </ng-container>clique numa linha para abrir a grade
  </span>
  <span class="espaco"></span>
  <button type="button" class="btn-ico" title="Atualizar" (click)="carregar()" [disabled]="carregando">
    <svg class="i" [class.girando]="carregando" viewBox="0 0 24 24"><path d="M20 11a8 8 0 0 0-14.6-4.5L4 8M4 4v4h4M4 13a8 8 0 0 0 14.6 4.5L20 16M20 20v-4h-4" /></svg>
  </button>
</div>

<div class="alerta bad" *ngIf="erro" role="alert">
  <svg class="i sm" viewBox="0 0 24 24"><path d="M12 3 2 21h20z" /><path d="M12 10v5M12 18h.01" /></svg>
  <div>{{ erro }}</div>
</div>

<div class="card vazio" *ngIf="!cdEstabelecimento">
  <b>Escolha a unidade</b>
  As agendas do dia são da unidade escolhida nos filtros.
</div>

<div class="card vazio" *ngIf="cdEstabelecimento && carregando && !agendas.length">Carregando agendas...</div>

<div class="card vazio" *ngIf="cdEstabelecimento && !carregando && !erro && !agendas.length">
  <b>Nenhuma agenda funciona neste dia</b>
  Agenda bloqueada, encerrada ou sem turno no dia não aparece.
</div>

<div class="card vazio" *ngIf="agendas.length && !quantidade">
  <b>Nenhuma agenda com esse termo</b>
  Busque pelo nome da agenda ou pela especialidade.
</div>

<ng-container *ngIf="quantidade">
  <section class="card bloco" *ngFor="let b of blocos" [class.carregando]="carregando" [attr.aria-label]="b.titulo">
    <h3>
      {{ b.titulo }}
      <span class="cont">{{ b.agendas.length }} agenda{{ b.agendas.length === 1 ? '' : 's' }}</span>
      <span class="cont" *ngIf="!b.comTotal">· vagas não entram no total</span>
    </h3>

    <p class="vazio-bloco" *ngIf="!b.agendas.length">Nenhuma agenda neste bloco.</p>

    <div class="tabela-wrap" *ngIf="b.agendas.length">
      <table class="lista">
        <colgroup>
          <col />
          <col class="c-tipo" />
          <col class="c-hor" />
          <col class="c-num" />
          <col class="c-num" />
          <col class="c-num" />
          <col class="c-ocup" />
        </colgroup>
        <thead>
          <tr>
            <th>Agenda</th>
            <th>Tipo</th>
            <th>Horário</th>
            <th class="num">Vagas</th>
            <th class="num">Agendadas</th>
            <th class="num">Livres</th>
            <th>Ocupação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of b.agendas" class="linha" title="Abrir a grade desta agenda" (click)="abrirNaAgenda(a)">
            <td>
              <span class="nome">{{ a.nmAgenda }}</span>
              <span class="sub2">{{ a.dsEspecialidade }}</span>
            </td>
            <td><span class="tag" [class.exam]="a.tipo === 'EXAME'">{{ rotuloTipo(a.tipo) }}</span></td>
            <td class="hor">{{ a.hrPrimeiro }} – {{ a.hrUltimo }}</td>
            <td class="num">{{ a.vagas }}</td>
            <td class="num">{{ a.agendadas }}</td>
            <td class="num"><b class="livres" [class.zero]="!a.livres">{{ a.livres }}</b></td>
            <td>
              <span class="ocup" [class.alta]="ocupacao(a) >= 80" [class.cheia]="ocupacao(a) >= 100">
                <span class="b"><i [style.width.%]="ocupacao(a) > 100 ? 100 : ocupacao(a)"></i></span>{{ ocupacao(a) }}%
              </span>
            </td>
          </tr>
          <tr *ngIf="b.comTotal" class="total">
            <td colspan="3">Total</td>
            <td class="num">{{ b.vagas }}</td>
            <td class="num">{{ b.agendadas }}</td>
            <td class="num">{{ b.livres }}</td>
            <td>{{ ocupacao(b) }}%</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</ng-container>

<p class="rodape" *ngIf="quantidade">Mesma contagem do relatório Agendamentos Unidade.</p>
